import type { Locale, Theme } from '../types';
import { chrome } from '../i18n';
import { icon } from '../components/Icon';

/** Full-screen login gate (client-side). Language toggle works before sign-in. */
export function LoginView(locale: Locale, theme: Theme, error = ''): string {
  const c = chrome(locale);
  return `
  <div class="login-wrap">
    <div class="login-card">
      <div class="login-brand">
        <div class="logo plat-logo">${icon('gauge', 'icon icon-logo')}</div>
      </div>

      <form id="loginForm" class="login-form" autocomplete="on">
        <label class="field">
          <span>${c.username}</span>
          <input id="loginUser" name="username" type="text" autocomplete="username" required />
        </label>
        <label class="field">
          <span>${c.password}</span>
          <input id="loginPass" name="password" type="password" autocomplete="current-password" required />
        </label>
        <div class="login-err ${error ? 'show' : ''}">${error ? `${icon('alert-circle', 'icon icon-xs')} ${error}` : ''}</div>
        <button class="login-btn" type="submit" id="loginBtn">${icon('log-in')} <span>${c.signIn}</span></button>
      </form>

      <div class="login-foot">
        <div class="toggle" role="group" aria-label="${c.langLabel}">
          <button type="button" data-lang="ar" class="${locale === 'ar' ? 'on' : ''}" lang="ar">العربية</button>
          <button type="button" data-lang="en" class="${locale === 'en' ? 'on' : ''}" lang="en">English</button>
        </div>
        <span class="login-note">${icon('lock', 'icon icon-xs')} ${c.loginNote}</span>
      </div>
    </div>
  </div>`;
}
